import type { Hook } from '../types';
import { globalConfig } from './globalConfig';
import { layout } from './layout';
import { parseDataMetaInfo } from './parseDataMetaInfo';
import { buildStandardChartPresetOption } from './buildStandardChartPresetOption';
import { beforeRenderStandardChart } from './beforeRenderStandardChart';
import { beforeRenderTimeline } from './beforeRenderTimeline';
import { getSplitLineNumber } from './getSplitLineNumber';
import { buildTooltip } from './buildTooltip';
import { formatDataNumberValue } from './formatDataNumberValue';
import { addSubChartSimpleHXKLine } from './addSubChartSimpleHXKLine';
import { getHXKLineTooltipData } from './getHXKLineTooltipData';
import { triggerLegendUpdater } from './triggerLegendUpdater';

export default {
  globalConfig,
  layout,
  parseDataMetaInfo,
  buildStandardChartPresetOption,
  beforeRenderStandardChart,
  beforeRenderTimeline,
  getSplitLineNumber,
  formatDataNumberValue,
  buildTooltip,
  addSubChartSimpleHXKLine,
  getHXKLineTooltipData,
  triggerLegendUpdater
} as Hook;
